import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../assets/css/Feedbackform/Feedbackform.css";
import { BASE_URL } from "../../store/config";
import ErrorModal from "../common/ErrorModal";
import Select from "react-select";

function FeedBackForm() {

  const [formType, setFormType] = useState("");
  const [formTypes, setFormTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(null);

  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const token = localStorage.getItem("access_token");

  useEffect(() => {

    if (!token) return;

    axios
      .get(`${BASE_URL}api/form-types`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setFormTypes(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setErrorModal({
          show: true,
          message: "Failed to load form types. Please try again.",
        });
      });

  }, [token]);

  const handleContinue = () => {

    if (!formType) {
      setErrorModal({
        show: true,
        message: "Please select Form Type",
        type: "error",
      });
      return;
    }

    axios
      .post(
        `${BASE_URL}api/forms-ques`,
        {
          form_type: parseInt(formType),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setFormData(res.data);
      })
      .catch((err) => {

        if (err.response?.status === 404) {
          setErrorModal({
            show: true,
            message: "No form issued for this type.",
          });
        } else {
          setErrorModal({
            show: true,
            message: "Something went wrong. Please try again.",
          });
        }

      });
  };

  const handleInputChange = (questionId, value) => {

    const updatedForm = { ...formData };

    updatedForm.questions = updatedForm.questions.map((q) =>
      q.id === questionId ? { ...q, value } : q
    );

    setFormData(updatedForm);
  };

  const handleBack = () => {
    setFormData(null);
  };

  const handleSubmit = async () => {

    try {

      for (const q of formData.questions) {

        if (q.is_required && (!q.value || q.value.length === 0)) {
          setErrorModal({
            show: true,
            message: `Please answer: ${q.question_text}`,
          });
          return;
        }

      }

      const answersJson = {};

      formData.questions.forEach((q) => {
        if (q.value !== undefined && q.value !== "") {
          answersJson[q.id] = q.value;
        }
      });

      const payload = {
        form_id: formData.id,
        feedback_type_id: parseInt(formType),
        answers_json: answersJson,
      };

      await axios.post(
        `${BASE_URL}api/forms-ans`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setErrorModal({
        show: true,
        message: "Feedback submitted successfully!",
        type: "success",
      });

      setFormData(null);
      setFormType("");

    } catch (err) {

      setErrorModal({
        show: true,
        message:
          err.response?.data?.detail ||
          "Error submitting feedback. Please try again.",
      });

    }

  };

  if (loading) return <p>Loading...</p>;

  return (

    <div className="feedback-card-container">

      <div className="feedback-card-header">
        <h2 className="feedback-card-title">Feedback</h2>

        <p className="feedback-card-quote">
          "Your feedback helps us improve our services."
        </p>

        <div className="feedback-card-divider"></div>
      </div>

      {!formData && (

        <div className="feedback-card-form">

          <div className="feedback-card-row">

            <label className="feedback-card-label">
              Form Type
            </label>

            <select
              className="select-form"
              value={formType}
              onChange={(e) => setFormType(e.target.value)}
            >
              <option value="">Select Form Type</option>

              {formTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>

          </div>

          <button
            className="feedback-card-continue"
            onClick={handleContinue}
          >
            Continue
          </button>

        </div>

      )}

      {formData && (

        <div className="fbq-form-wrapper">

          <div className="fbq-form-header">
            <h3 className="fbq-form-title">
              {formData.title}
            </h3>
          </div>

          <div className="fbq-scroll-area">

            {formData.questions.map((q) => {

              if (q.is_delete) return null;

              return (

                <div
                  key={q.id}
                  className="fbq-question-block"
                >

                  {/* TEXT */}
                  {q.field_type === "text" && (

                    <div className="fbq-input-group">

                      <input
                        type="text"
                        className="fbq-input"
                        value={q.value || ""}
                        onChange={(e) =>
                          handleInputChange(
                            q.id,
                            e.target.value
                          )
                        }
                        placeholder=" "
                      />

                      <label className="fbq-floating-label">
                        {q.question_text}

                        {q.is_required && (
                          <span className="fbq-required">*</span>
                        )}

                      </label>

                    </div>

                  )}

                  {/* TEXTAREA */}
                  {q.field_type === "textarea" && (

                    <>

                      <label className="fbq-question-label">
                        {q.question_text}
                      </label>

                      <textarea
                        className="fbq-textarea"
                        value={q.value || ""}
                        onChange={(e) =>
                          handleInputChange(
                            q.id,
                            e.target.value
                          )
                        }
                      />

                    </>

                  )}

                  {/* RADIO */}
                  {q.field_type === "radio" && (

                    <>

                      <label className="fbq-question-label">
                        {q.question_text}
                      </label>

                      <div className="fbq-options">

                        {q.options?.map((opt) => (

                          <label
                            key={opt}
                            className="fbq-option-item"
                          >

                            <input
                              type="radio"
                              name={`radio-${q.id}`}
                              value={opt}
                              checked={q.value === opt}
                              onChange={(e) =>
                                handleInputChange(
                                  q.id,
                                  e.target.value
                                )
                              }
                            />

                            <span>{opt}</span>

                          </label>

                        ))}

                      </div>

                    </>

                  )}

                  {/* CHECKBOX */}
                  {q.field_type === "checkbox" && (

                    <>

                      <label className="fbq-question-label">
                        {q.question_text}
                      </label>

                      <div className="fbq-options">

                        {q.options?.map((opt) => (

                          <label
                            key={opt}
                            className="fbq-option-item"
                          >

                            <input
                              type="checkbox"
                              checked={q.value?.includes(opt)}
                              onChange={(e) => {

                                const newValue =
                                  e.target.checked
                                    ? [...(q.value || []), opt]
                                    : (q.value || []).filter(
                                      (v) => v !== opt
                                    );

                                handleInputChange(
                                  q.id,
                                  newValue
                                );

                              }}
                            />

                            <span>{opt}</span>

                          </label>

                        ))}

                      </div>

                    </>

                  )}

                  {/* DATE */}
                  {q.field_type === "date" && (

                    <>

                      <label className="fbq-question-label">
                        {q.question_text}
                      </label>

                      <input
                        type="date"
                        className="fbq-input"
                        value={q.value || ""}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) =>
                          handleInputChange(
                            q.id,
                            e.target.value
                          )
                        }
                      />

                    </>

                  )}

                  {/* SELECT (Searchable) */}
                  {q.field_type === "select" && (

                    <>

                      <label className="fbq-question-label">
                        {q.question_text}
                      </label>

                      <Select
                        options={q.options?.map((opt) => ({
                          label: opt,
                          value: opt,
                        }))}
                        value={
                          q.value
                            ? {
                              label: q.value,
                              value: q.value,
                            }
                            : null
                        }
                        onChange={(selected) =>
                          handleInputChange(
                            q.id,
                            selected?.value
                          )
                        }
                        placeholder="Select an option"
                        className="fbq-react-select"
                      />

                    </>

                  )}

                </div>

              );

            })}

          </div>

          <div className="fbq-action-buttons">

            <button
              className="fbq-back-btn"
              onClick={handleBack}
            >
              Back
            </button>

            <button
              className="fbq-submit-btn"
              onClick={handleSubmit}
            >
              Submit Feedback
            </button>

          </div>

        </div>

      )}

      <ErrorModal
        show={errorModal.show}
        message={errorModal.message}
        type={errorModal.type}
        onClose={() =>
          setErrorModal({
            show: false,
            message: "",
            type: "error",
          })
        }
      />

    </div>

  );

}

export default FeedBackForm;
